import { hotItems } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

const tagStyle: Record<string, string> = {
  新: "bg-accent-500/15 text-accent-300 border-accent-500/30",
  热: "bg-primary-500/15 text-primary-300 border-primary-500/30",
  沸: "bg-secondary-500/15 text-secondary-300 border-secondary-500/30",
};

function HotRank() {
  return (
    <section id="hot" className="relative py-16 md:py-24">
      <div className="container-x">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <SectionHeading
              eyebrow="实时聚合 · 人工筛选"
              title="今日热榜，热度之外有门道"
              desc="我们不搬运情绪，只把每一条热点背后值得深挖的方向标出来，告诉你接下来该往哪儿看。"
            />

            <ol className="mt-9 space-y-2" aria-label="今日热榜">
              {hotItems.map((item) => (
                <li key={item.rank}>
                  <a
                    href="#featured"
                    className="group flex items-center gap-4 rounded-xl border border-transparent px-3 py-3 transition-colors hover:border-background-800 hover:bg-background-900"
                  >
                    <span
                      className={`w-8 shrink-0 text-center font-serif text-xl font-black ${
                        item.rank <= 3 ? "text-primary-400" : "text-foreground-600"
                      }`}
                    >
                      {String(item.rank).padStart(2, "0")}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-[15px] text-foreground-100 transition-colors group-hover:text-primary-300">
                        {item.title}
                      </span>
                    </span>
                    <span
                      className={`hidden shrink-0 items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs sm:inline-flex ${tagStyle[item.tag]}`}
                    >
                      {item.tag}
                    </span>
                    <span className="hidden shrink-0 items-center gap-1 text-sm text-foreground-500 md:flex">
                      {item.trend === "up" ? (
                        <i className="ri-arrow-up-line text-accent-400" aria-hidden="true"></i>
                      ) : item.trend === "down" ? (
                        <i className="ri-arrow-down-line text-primary-400" aria-hidden="true"></i>
                      ) : (
                        <i className="ri-more-fill text-foreground-600" aria-hidden="true"></i>
                      )}
                      {item.heat}
                    </span>
                  </a>
                </li>
              ))}
            </ol>

            <div className="mt-6 flex items-center justify-between border-t border-background-800 pt-5">
              <p className="text-sm text-foreground-500">
                每 30 分钟更新 · 以公开讨论热度为参考，不代表任何倾向性结论
              </p>
              <a
                href="#columns"
                className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-accent-300 transition-colors hover:text-accent-200"
              >
                换个角度看热榜
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="sticky top-24 rounded-2xl border border-background-800 bg-gradient-to-b from-background-900 to-background-950 p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-500 text-background-950">
                  <i className="ri-eye-2-line text-xl" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="font-serif text-lg font-semibold text-foreground-100">为什么读黑屋</p>
                  <p className="text-xs text-foreground-500">WEEKLY INSIGHT</p>
                </div>
              </div>
              <ul className="mt-6 space-y-5">
                {[
                  ["只看热点，不消费情绪", "不消费当事人，不渲染对立。"],
                  ["把瓜拆到创作与行业层面", "还原来龙去脉，比结论更耐读。"],
                  ["标注待核实部分", "对无法确证的信息，诚实呈现边界。"],
                ].map(([t, d], i) => (
                  <li key={t} className="flex gap-4">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-500/15 font-serif text-sm font-bold text-primary-300">
                      {i + 1}
                    </span>
                    <div>
                      <p className="text-sm font-medium text-foreground-100">{t}</p>
                      <p className="mt-0.5 text-sm leading-relaxed text-foreground-500">{d}</p>
                    </div>
                  </li>
                ))}
              </ul>
              <a
                href="#about"
                className="mt-6 flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-700 py-2.5 text-sm text-foreground-100 transition-colors hover:border-accent-500/50 hover:text-accent-300"
              >
                了解内容原则
                <i className="ri-arrow-down-line" aria-hidden="true"></i>
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default HotRank;